<template>

  <v-card>


    <v-data-table :headers="headers1()"
                  :items="tableData"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  class="v-icon-fix custom-table-header"
                  :pagination.sync="pagination">

      <template slot="headerCell" slot-scope="{ header }">
        <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
      </template>

      <template slot="items" slot-scope="{ index, item }">
        <ExamTr :item="item" :index="index" @examRowClick="passEvent"></ExamTr>
      </template>
    </v-data-table>
  </v-card>
</template>


<script>
  import ExamTr from './ExamTR.vue'
  export default {
    name: 'ExamTermsTable',
    props: {
      titleColor: '',
      tableData: {
        type: Array, default: function () {
          return [];
        }
      },
      passEvent: {
        type: Function
      }
    },
 

    data() {
      return {
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false
        },

        pagination: {
          rowsPerPage: 100
        }
      }
    },


    methods: {
      headers1() {
        return [
          {
            sortable: false,
            text: this.$t('exam_register.terms_table_headers.term_date'),
            value: 'center'
          },
          {
            sortable: false,
            text: this.$t('exam_register.terms_table_headers.term_time'),
            value: 'Vrijeme',
            align: 'center'
          },
          {
            sortable: false,
            text: this.$t('exam_register.terms_table_headers.classroom'),
            value: 'Ucionica',
            align: 'left'
          },
          {
            sortable: false,
            text: this.$t('exam_register.terms_table_headers.address'),
            value: 'Adresa',
            align: 'left'
          },
          {
            sortable: false,
            text: '',
            value: 'Button',
            align: 'center'
          },

        ]
      }
    },

    components: {
      ExamTr
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Exams/exam_register_components/ExamTermsTable.vue